import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const ScrollHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const headerHeight = 100; // Höhe des Headers in Pixeln für den korrekten Abstand

    if (location.hash) {
      // Eine kleine Verzögerung ist wichtig, damit die neue Seite erst rendern kann
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          const topPos = element.getBoundingClientRect().top + window.pageYOffset - headerHeight;
          window.scrollTo({
            top: topPos,
            behavior: 'smooth'
          });
        }
      }, 100); // 100 Millisekunden Verzögerung
    } else {
      // Wenn kein # in der URL ist, einfach nach oben scrollen
      window.scrollTo(0, 0);
    }
  }, [location]); // Effekt bei jeder Änderung der URL ausführen

  return null; // Diese Komponente rendert nichts
};

export default ScrollHandler;